import React, { useState } from "react";
import immutiverseLogo from "../assets/icons/Immutaverse+Blue+White+Logo.webp";
import linkedinIcon from "../assets/icons/linkedinIcon.png";
import twitterIcon from "../assets/icons/twitterIcon.png";
import "../assets/styles/Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSignUp = (e) => {
    e.preventDefault();
  };

  return (
    <footer className="custom-footer">
      {/* ── Top: nav columns ── */}
      <div className="footer-container">
        {/* Logo + Socials */}
        <div className="footer-column logo-column">
          <a href="https://www.immutaverse.com/">
            <img
              src={immutiverseLogo}
              alt="Immutaverse Logo"
              className="footer-logo"
             
            />
          </a>
        </div>

        {/* Platform */}
        <div className="footer-column platform-column">
          <h3>PLATFORM</h3>
          <ul>
            <li><a href="https://www.immutaverse.com/immutaverse-apex">Immutaverse Apex</a></li>
            <li><a href="https://www.immutaverse.com/immutaverse-origin">Immutaverse Origin</a></li>
            <li><a href="https://www.immutaverse.com/immutaverse-radar">Immutaverse Radar</a></li>
            <li><a href="https://www.immutaverse.com/immutaverse-regen">Immutaverse Regen</a></li>
          </ul>
        </div>

        {/* Solutions */}
        <div className="footer-column platform-column">
          <h3>SOLUTIONS</h3>
          <ul>
            <li><a href="https://www.immutaverse.com/oem-new-product-introduction">OEM New Product Introduction</a></li>
            <li><a href="https://www.immutaverse.com/scalable-oem-device-security-workflows">Scalable OEM Device Security Workflows</a></li>
            <li><a href="https://www.immutaverse.com/product-security-regulatory-compliance">Product Security Regulatory Compliance</a></li>
          </ul>
        </div>

        {/* Company */}
        <div className="footer-column about-column">
          <h3>COMPANY</h3>
          <ul>
            <li><a href="https://www.immutaverse.com/company">About Us</a></li>
            <li><a href="https://www.immutaverse.com/privacy-policy">Privacy Policy</a></li>
            <li><a href="https://www.immutaverse.com/cookie-policy">Cookie Policy</a></li>
          </ul>
        </div>
      </div>
          <div className="social-row">
            <a
              href="https://www.linkedin.com/company/immutaverseinc"
              target="_blank"
              rel="noopener noreferrer"
              className="social-box"
              aria-label="LinkedIn"
            >
              <img src={linkedinIcon} alt="LinkedIn" className="social-icon" width={200} height={200} />
            </a>
            <a
              href="https://x.com/immutaverse"
              target="_blank"
              rel="noopener noreferrer"
              className="social-box"
              aria-label="X / Twitter"
            >
              <img src={twitterIcon} alt="X / Twitter" className="social-icon" />
            </a>
          </div>

      {/* ── Bottom row ── */}
      <div className="footer-bottom">
        <p className="footer-copy">© 2026 Immutaverse, Inc.</p>

        {/* Join the movement card */}
        <div className="join-card">
          <h2 className="join-title">Join the movement</h2>
          <p className="join-subtitle">
            Get early access to product security risks, exploit trends, and
            predictions on what regulators will require next.
          </p>
          <div className="join-form-row">
            <input
              type="email"
              className="join-input"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className="join-btn" onClick={handleSignUp}>
              Sign Up
            </button>
          </div>
          <p className="join-terms">
            By submitting this form, you accept our Terms of Service &amp;{" "}
            <a href="https://www.immutaverse.com/privacy-policy" className="join-policy-link">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;